module.exports = __webpack_public_path__ + "static/media/All_Round_Gothic_Demi.fab42eb0.woff";